// extracted by mini-css-extract-plugin
export default {"fullDiv":"footer_fullDiv__7tgQS","mainFooter":"footer_mainFooter__gFjCn","contact":"footer_contact__tVCm2","lastDiv":"footer_lastDiv__9S0zy"};